<template>
  <web-index></web-index>
  <RightSideBar/>
  <ChatWindow />
</template>

<script setup>
import webIndex from "@/views/index/webIndex.vue";
import RightSideBar from "@/components/RightSideBar/RightSideBar.vue";
import ChatWindow  from "@/components/ChatWindow/ChatWindow.vue";
import {provide,ref} from "vue";
import { onMounted, onBeforeUnmount } from 'vue'


const isChatWindowOpen = ref(true);
provide('isChatWindowOpen', isChatWindowOpen);

/**
 * resize 重新计算方法
 */
const resize = () => {
  const deviceWidth = document.documentElement.clientWidth
  document.documentElement.style.fontSize = deviceWidth / 375 + 'px'
}

onMounted(() => {
  resize()
  window.addEventListener('resize', resize)
})

// 销毁钩子函数
onBeforeUnmount(() => {
  window.removeEventListener('resize', resize)
})
</script>

<style>
/* 添加到你的全局样式文件中 */
html, body {
  margin: 0;
  padding: 0;
}
header {
  line-height: 1.5;
  max-height: 100vh;
}

.logo {
  display: block;
  margin: 0 auto 2rem;
}

nav {
  width: 100%;
  font-size: 12px;
  text-align: center;
  margin-top: 2rem;
}

nav a.router-link-exact-active {
  color: var(--color-text);
}

nav a.router-link-exact-active:hover {
  background-color: transparent;
}

nav a {
  display: inline-block;
  padding: 0 1rem;
  border-left: 1px solid var(--color-border);
}

nav a:first-of-type {
  border: 0;
}

@media (min-width: 1024px) {
  header {
    display: flex;
    place-items: center;
    padding-right: calc(var(--section-gap) / 2);
  }

  .logo {
    margin: 0 2rem 0 0;
  }

  header .wrapper {
    display: flex;
    place-items: flex-start;
    flex-wrap: wrap;
  }

  nav {
    text-align: left;
    margin-left: -1rem;
    font-size: 1rem;

    padding: 1rem 0;
    margin-top: 1rem;
  }
}
</style>
